import React from "react"

function IconFlagAlt({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="flag-alt"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-flag-alt"
      {...props}
    >
      <path
        d="M6.655 21.055a.655.655 0 0 1-1.301.106l-.009-.106V6.32a1.91 1.91 0 1 1 1.31 0v1.534H12.5c.214 0 .411.103.533.274l.054.09.793 1.606h5.075c.326 0 .595.238.646.55l.009.105v7.983a.655.655 0 0 1-.549.646l-.106.009h-5.482a.655.655 0 0 1-.525-.264l-.055-.087-.79-1.507H6.656v3.795zm0-5.104H12.5c.209 0 .403.1.525.264l.055.087.788 1.506H18.3v-6.674h-4.827a.655.655 0 0 1-.533-.273l-.054-.091-.793-1.606H6.655v6.787z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconFlagAlt
